import {useStore} from 'vuex'
import {ref, computed, onMounted, watch} from 'vue'
import ProductSpot from '../ProductSpot/ProductSpot.vue'
import FilterComponent from '../FilterComponent/FilterComponent.vue'
import FilterComponentControls from '../FilterComponent/FilterComponentControls.vue'

export default {
    name: "ProductGrid",
    components:{
        ProductSpot,
        FilterComponent,
        FilterComponentControls
    },
    setup(){
        const store = useStore()

        const productList = computed(()=>store.getters['productSearch/productsList'])
        const noProductsToShow = computed(()=> productList.length === 0)
        const takeValue = computed(()=>store.getters['productSearch/nextTakeValue'])
        const spinnerVisible = computed(()=>store.state.productSearch.search_spinner_visible)
        const ambienceToggle = store.state.main.ambience_toggle

        const gridContainer = ref(null) 
        const gridContainerWidth = ref(0)
        const gridContainerModifier = computed(()=>{
            if(gridContainerWidth.value < 330) return 'nlx-product-grid__products-container--1tile'
            if(gridContainerWidth.value < 960) return 'nlx-product-grid__products-container--2tiles'
            if(gridContainerWidth.value < 1260) return 'nlx-product-grid__products-container--3tiles'
            
            return 'nlx-product-grid__products-container--4tiles'
        })
        const updateGridContainerWidth = function(){
            gridContainerWidth.value = gridContainer.value.clientWidth
        }

        const displayingFilterColumn = computed(() => store.state.productSearch.filterColumnVisible ? 'nlx-product-grid__filter-container--visible' : '')
        watch(displayingFilterColumn,()=>{            
            setTimeout(() => {
                updateGridContainerWidth()
            }, 1);
        })

        const loadMoreResults = () => {
            store.dispatch('productSearch/loadMore')
        }
        const moreResultsAvailable = computed(()=>store.getters['productSearch/moreResultsAvailable'])

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        store.dispatch('main/windowOnresize',updateGridContainerWidth)

        onMounted(updateGridContainerWidth)

        return {
            ambienceToggle,
            displayingFilterColumn,
            getLabel,
            gridContainer,
            gridContainerModifier,
            gridContainerWidth,
            noProductsToShow,
            productList,
            loadMoreResults,
            moreResultsAvailable,
            spinnerVisible,
            takeValue
        }
    }
}